import { Inject, Injectable } from '@angular/core';
import { VersionApiService } from '@thehubz/client/data-access-api';
import { Observable, interval, map, mergeMap } from 'rxjs';
import { ClientEnvironment, ENVIRONMENT } from '../environment';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  versionChanged$: Observable<boolean>;

  constructor(@Inject(ENVIRONMENT) env: ClientEnvironment, versionService: VersionApiService) {
    this.versionChanged$ = interval(5 * 60 * 1000).pipe(
      mergeMap(() => {
        return versionService.appVersionControllerVersion().pipe(
          map((version) => {
            if (version.version.trim() !== env.appVersion?.trim()) {
              console.log(`app version ${env.appVersion} updated to ${version.version}`);
              return true;
            }
            console.log(`app version ${env.appVersion} up-to-date`);
            return false;
          }),
        );
      }),
    );
  }
}
